import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { incidentReportActions } from '../../../redux/slices/incidentReportSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useIncidentReport = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onIncidentReportDataError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onIncidentReportDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<IncidentReportDataInterface>) => {
        dispatch(incidentReportActions.setIncidentReportData(data));
    };

    const getIncidentReportData = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/report-summary`,
            method: 'get',

        };
        request(url, onIncidentReportDataSuccess, setLoading, onIncidentReportDataError);
    };

    return { getIncidentReportData, loading };
};

export default useIncidentReport;


export interface IncidentReportDataInterface {
    activeDriverCount: number;
    logiScore: number;
    baseline: number;
    difference: number;
    incidentDistribution: IncidentDistribution;
}

export interface IncidentDistribution {
    totalReports: number;
    theftReports: number;
    accidentReports: number;
    avgTheftSeverity: number;
    avgAccidentSeverity: number;
    reportRate: number;
}
